export const environment = {
  production: false,
  apiBase: 'https://erpstgiiback.maids.cc:7443',
  newErp: true,
  googleRedirectUri: 'https://staging-ii.maids.cc/external-google-login.html',
  oldPublicPagesRoute: 'https://tmp-stagingii.maids.cc/',
};
